Ext.define('SA.view.LoadMask', {
    alias: 'widget.load-mask',
    extend: 'SA.view.SimpleContainer',

    baseCls: 'sa-load-mask',
    borderColor: null,
    defaultBackgroundColor: 'rgba(252, 252, 252, 0.8)',
    spinnerSize: 'large',
    transparentBackground: false,
    zIndex: 1,

    initComponent() {
        this.items = [{xtype: 'boxed-spinner', size: this.spinnerSize}];

        this.callParent();

        this.protoEl.setStyle({zIndex: this.zIndex});

        if (!this.transparentBackground) {
            this.setBackgroundColor(this.backgroundColor ?? this.defaultBackgroundColor);
        }

        if (this.borderColor) {
            this.protoEl.setStyle({border: `1px solid ${this.borderColor}`});
        }
    },

    applyDefaultBackgroundColor() {
        this.setBackgroundColor(this.defaultBackgroundColor);
    },

    getHidePromise() {
        return new Promise(resolve => {
            if (this.isVisible()) {
                this.on('hide', resolve, null, {single: true});
            }
            else {
                resolve();
            }
        });
    },

    setBackgroundColor(backgroundColor) {
        (this.el ?? this.protoEl).setStyle({backgroundColor});
    }
});